// packages/api-client/queries/discountCodes/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createDiscountCodesQueries = (requests, queryClient) => ({
    useListDiscountCodes: (params, options = {}) => useQuery({
        queryKey: ["discount-codes", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listDiscountCodes(params);
        },
        ...options,
    }),
    useCreateDiscountCode: (options = {}) => useMutation({
        ...options,
        mutationFn: (discountCodeAttrs) => {
            return requests.createDiscountCode(discountCodeAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["discount-codes"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDeleteDiscountCode: (options = {}) => useMutation({
        ...options,
        mutationFn: (discountCodeId) => {
            return requests.deleteDiscountCode(discountCodeId);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["discount-codes"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useValidateDiscountCode: (options = {}) => useMutation({
        ...options,
        mutationFn: (discountCodeAttrs) => {
            return requests.validateDiscountCode(discountCodeAttrs);
        },
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map